/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Lock_LabelInputs */

const en_landing_studio_lock_label = /** @type {(inputs: Landing_Studio_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pixel Lock`)
};

const zh_landing_studio_lock_label = /** @type {(inputs: Landing_Studio_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`像素锁定`)
};

/**
* | output |
* | --- |
* | "Pixel Lock" |
*
* @param {Landing_Studio_Lock_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_lock_label = /** @type {((inputs?: Landing_Studio_Lock_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Lock_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_lock_label(inputs)
	return zh_landing_studio_lock_label(inputs)
});
export { landing_studio_lock_label as "landing.studio.lock_label" }